import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
  List,
  InputItem,
  Modal,
} from "antd-mobile";
import { type } from "os";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../../util/axios";
const JixiaoList = styled.div`
  .body {
    height: 100%;
  }
  .month p {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d7d7d7;
  }
  .am-list-item .am-input-label.am-input-label-5 {
    width: 170px;
  }
  .center {
    text-align: center;
  }
`;
interface scoreArray {
  name: string;
  minScore: string;
  maxScore: string;
}
export default function KhOrganization() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
  }>({
    visible: false,
  });
  const [text1, setText1] = useState<string>("");
  const [text2, setText2] = useState<string>("");
  const [text3, setText3] = useState<string>("");
  const [text4, setText4] = useState<string>("");
  const [text5, setText5] = useState<string>("");
  const [detailsList, setDetailsList] = useState<{ [key: string]: any }>({
    Value: "",
  });
  const history = useHistory();
  const [standardList, setStandardList] = useState<scoreArray[]>([]);
  const [starttimeList, setStarttimeList] = useState<{
    time: number;
  }>({ time: 1 });
  const [endtimeList, setEndtimeList] = useState<{
    time: number;
    status: string;
  }>({ time: 1, status: "" });
  const [informationList, setInformationList] = useState<{
    uuid: string;
  }>({
    uuid: "",
  });

  const [type, setType] = useState<string>("");
  // 评分标准
  useEffect(() => {
    instance
      .get(
        `/oa/examSetting/standardSetting/getScoreRangeStandardList?timeType=` +
          "month"
      )
      .then((resp) => {
        // console.log(resp)
        // console.log(resp.data.Data.data)
        if (resp.data.Status === "1") {
          setStandardList(resp.data.Data);
          // console.log(staffList)
        }
      });
  }, []);
  useEffect(() => {
    // 获取现在时间
    const nowTime1 = new Date();
    // console.log(nowTime1)
    console.log(nowTime1.getTime());
    const nowTime = nowTime1.getTime();
    setStarttimeList({
      ...starttimeList,
      time: nowTime,
    });
    let url = decodeURI(window.location.href); //获取请求进来的完整url
    // console.log(url)
    let tstr = url.substring(url.indexOf("?") + 1).split("&"); //先截取url的?后面的参数部分，在根据&分割成参数数组
    console.log(tstr);
    let tstr0 = tstr[0].substring(9);
    let tstr1 = tstr[1];
    setInformationList({
      uuid: tstr1,
    });
    instance
      .post(
        `/oa/examYear/getExecuteYearDepartList?permissionType=departMe&type=departFunction&vSheetId=` +
          tstr0
      )
      .then((resp) => {
        // console.log(resp.data.Data.data)
        // console.log(resp)
        if (resp.data.Status == 1) {
          let arr1 = resp.data.Data.data;
          instance
            .post(
              `/oa/examYear/getExecuteYearDepartList?permissionType=departMe&type=departBusiness&vSheetId=` +
                tstr0
            )
            .then((resp) => {
              if (resp.data.Status == 1) {
                let arr2 = resp.data.Data.data;
                let arr = arr1.concat(arr2);
                console.log(arr);
                let data0 = arr.find((item: any) => item.uuid === tstr1);
                console.log(data0);
                let name = data0.beTestedDepartmentCode.substring(
                  0,
                  data0.beTestedDepartmentCode.indexOf("c")
                );
                let department = data0.beTestedCategoryId;
                if (department == 1) {
                  setType("职能部门");
                } else if (department == 2) {
                  setType("业务部门");
                }
                // 职能125
                setText1(data0.workQuality); //工作质量
                setText2(data0.workEfficiency); //工作效率
                // 业务35
                setText3(data0.publicEngagement); //公共事务参与度
                setText4(data0.chargingPerformance); //收费业绩评价(带出)
                //管理成效
                setText5(data0.managementPerformance);
                setDetailsList({
                  name: name,
                  type: type,
                  managementPerformance: data0.managementPerformance,
                  workQuality: data0.workQuality,
                  workEfficiency: data0.workEfficiency,
                });
              }
            });
        }
      });
    instance
      .get(
        `/oa/examYear/getYearNoticeExecuteDepartList?permissionType=` +
          "departMe"
      )
      .then((resp) => {
        console.log(resp);
        // console.log(resp.data.Data.data)
        // // 获取结束时间
        if (resp.data.Status === "1") {
          let data1 = resp.data.Data.data.find(
            (item: any) => item.vSheetId === tstr0
          );
          console.log(data1);
          const khTime = new Date(data1.考核结束时间).getTime();
          console.log(khTime);
          const Status = data1.status;
          setEndtimeList({
            ...endtimeList,
            time: khTime,
            status: Status,
          });
        }
      });
  }, []);
  return (
    <>
      <JixiaoList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  // history.push(`/hr/jxassessment/yearassessment/organization`);
                  history.go(-1);
                }}
              />
            }
          >
            考核
          </NavBar>
          <WhiteSpace />
          <div style={{ padding: "10px 20px 10px 20px" }} className="month">
            {
              <>
                <p>
                  <span>被考核部门</span>
                  <span>{detailsList.name}</span>
                </p>
                <p>
                  <span>部门类别</span>
                  <span>{type}</span>
                </p>
                <p>
                  <span>工作报告</span>
                  <span>工作报告名</span>
                </p>
              </>
            }
          </div>
          {/* 职能部门 */} {/* 业务部门 */}
          {type == "职能部门" ? (
            <List>
              <InputItem
                type="number"
                placeholder="必填"
                value={text1}
                onChange={(value) => {
                  console.log(value);
                  setText1(value);
                }}
                clear
                style={{ padding: "0px 20px 0px 20px" }}
              >
                <span style={{ color: "red" }}>*</span>工作质量评价
              </InputItem>
              <InputItem
                type="number"
                placeholder="必填"
                value={text2}
                onChange={(value) => {
                  console.log(value);
                  setText2(value);
                }}
                clear
                style={{ padding: "0px 20px 0px 20px" }}
              >
                <span style={{ color: "red" }}>*</span>工作效率评价
              </InputItem>
            </List>
          ) : (
            <List>
              <InputItem
                type="number"
                placeholder="必填"
                value={text4}
                editable={false}
                onChange={(value) => {
                  console.log(value);
                  setText4(value);
                }}
                clear
                style={{ padding: "0px 20px 0px 20px" }}
              >
                收费业绩评价
              </InputItem>
              <InputItem
                type="number"
                placeholder="必填"
                value={text3}
                onChange={(value) => {
                  console.log(value);
                  setText3(value);
                }}
                clear
                style={{ padding: "0px 20px 0px 20px" }}
              >
                <span style={{ color: "red" }}>*</span>公共事务参与度评价
              </InputItem>
            </List>
          )}
          {/* 职能部门，业务部门都有 */}
          <List>
            <InputItem
              type="number"
              placeholder="必填"
              value={text5}
              onChange={(value) => {
                console.log(value);
                setText5(value);
              }}
              clear
              style={{ padding: "0px 20px 0px 20px" }}
            >
              <span style={{ color: "red" }}>*</span>管理成效评价
            </InputItem>
          </List>
          <p style={{ padding: "0px 20px 0px 20px" }}>
            <span
              style={{ color: "#108ee9" }}
              onClick={() =>
                setTankuang({
                  visible: true,
                })
              }
            >
              查看评价标准
            </span>
          </p>
          {type == "职能部门" ? (
            endtimeList.status == "未全部打分未提报" ||
            endtimeList.status == "已全部打分未提报" ||
            starttimeList.time < endtimeList.time ? (
              <div style={{ padding: "0px 20px 0px 20px", marginTop: 130 }}>
                <Button
                  type="primary"
                  onClick={() => {
                    if (text1 == "" || text2 == "" || text5 == "") {
                      Toast.info("请填写必填项");
                    } else {
                      instance
                        .post(
                          `/oa/examYear/saveExamYearDepartMarkScore?uuid=` +
                            informationList.uuid +
                            "&workQuality=" +
                            text1 +
                            "&workEfficiency=" +
                            text2 +
                            "&managementPerformance=" +
                            text5
                        )
                        .then((resp) => {
                          // console.log(resp)
                          if (resp.data.Status === "1") {
                            Toast.info(resp.data.Data);
                            setTimeout(function () {
                              history.go(-1);
                            }, 1500);
                          } else {
                            Toast.info(resp.data.Message);
                          }
                        });
                    }
                  }}
                >
                  提交
                </Button>
                <WhiteSpace />
              </div>
            ) : (
              <p className="center">职能部门考核结束</p>
            )
          ) : endtimeList.status == "未全部打分未提报" ||
            endtimeList.status == "已全部打分未提报" ||
            starttimeList.time < endtimeList.time ? (
            <div style={{ padding: "0px 20px 0px 20px", marginTop: 130 }}>
              <Button
                type="primary"
                onClick={() => {
                  if (text3 == "" || text5 == "") {
                    Toast.info("请填写必填项");
                  } else {
                    instance
                      .post(
                        `/oa/examYear/saveExamYearDepartMarkScore?uuid=` +
                          informationList.uuid +
                          "&publicEngagement=" +
                          text3 +
                          "&managementPerformance=" +
                          text5
                      )
                      .then((resp) => {
                        // console.log(resp)
                        if (resp.data.Status === "1") {
                          Toast.info(resp.data.Data);
                          setTimeout(function () {
                            history.go(-1);
                          }, 1500);
                        } else {
                          Toast.info(resp.data.Message);
                        }
                      });
                  }
                }}
              >
                提交2
              </Button>
              <WhiteSpace />
            </div>
          ) : (
            <p className="center">业务部门考核结束</p>
          )}
          <Modal
            visible={tankuang.visible}
            transparent
            maskClosable={false}
            onClose={() =>
              setTankuang({
                visible: false,
              })
            }
            title="评价标准"
            footer={[
              {
                text: "关闭",
                onPress: () => {
                  setTankuang({
                    visible: false,
                  });
                },
              },
            ]}
          >
            <div style={{ height: 200, overflow: "scroll" }}>
              {standardList.map((item) => (
                <>
                  <p>
                    {item.name}[{item.minScore},{item.maxScore})
                  </p>
                </>
              ))}
            </div>
          </Modal>
        </div>
      </JixiaoList>
    </>
  );
}
